import { useFeatureGate } from '@statsig/react-bindings';

import { logger } from '../datadog/logger';
import { useTrackEvent } from '../segment/segment';
import { EventTypeEnum } from '../segment/types';
import { localizationTelehealthClientGate } from '../statsig/gates';
import { normalizeError } from '../utils';
import { LanguageSwitcher } from './LanguageSwitcher';

export function LanguageSwitcherWrapper() {
  const { value: isEnabled } = useFeatureGate(localizationTelehealthClientGate);
  const { userClicked, userViewed } = useTrackEvent();
  if (!isEnabled) return null;
  return (
    <LanguageSwitcher
      onOpenSwitcher={(current) => userClicked(EventTypeEnum.LANGUAGE_SWITCHER_MODAL_TRIGGER, { current })}
      onModalViewed={(current) => userViewed(EventTypeEnum.PREFERRED_LANGUAGE_MODAL_VIEWED, { current })}
      onLanguageSaved={(previous, current) =>
        userClicked(EventTypeEnum.LANGUAGE_SWITCHER_MODAL_SAVE, { previous, current })
      }
      onLanguageChangeError={(error, context) =>
        logger.error('Failed to change language from language switcher modal', context, normalizeError(error))
      }
    />
  );
}
